'use client'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { i18n as i18nConfig } from '@/core/configs/i18n'
import { en } from './en'
import { fa } from './fa'
import { fr } from './fr'
import { ar } from './ar'

export const languages = i18nConfig.locales
export const defaultLang = i18nConfig.defaultLocale

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fa: { translation: fa },
      fr: { translation: fr },
      ar: { translation: ar }
    },
    lng: defaultLang,
    fallbackLng: defaultLang,
    supportedLngs: languages,
    interpolation: { escapeValue: false },
    detection: {
      order: ['path', 'cookie', 'localStorage', 'navigator'],
      caches: ['cookie'],
      lookupFromPathIndex: 0
    }
  })

export default i18n

export type TranslationKeys = keyof typeof en

export const t = (key: TranslationKeys, options?: Record<string, string>): string => i18n.t(key, options)
